import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	bodyGrid: {
		display: 'grid',
		gridTemplateColumns: '440px 1fr',
		gap: 20, // 20px content-grid gap per 1c design
		alignItems: 'flex-start',
		padding: THEME.spacing.lg,
		[THEME.queries.lg]: {
			gridTemplateColumns: '1fr',
		},
	},
	leftColumn: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		minWidth: 0,
	},
	rightColumn: {
		minWidth: 0,
	},
});
